/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S1_MetaInputs */

const en_mk_abt_s1_meta = /** @type {(inputs: Mk_Abt_S1_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const id_mk_abt_s1_meta = /** @type {(inputs: Mk_Abt_S1_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Mk_Abt_S1_MetaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s1_meta = /** @type {((inputs?: Mk_Abt_S1_MetaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S1_MetaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s1_meta(inputs)
	return en_mk_abt_s1_meta(inputs)
});